import axios from 'axios'
import {
    logout,
} from '@/helpers/axios'
import {
    Notification,
} from 'element-ui'
import $router from '../../router/index'

// Work with cookie Start
const getCookie = (name) => {
    const matches = document.cookie.match(
        new RegExp(
            `(?:^|; )${
                // eslint-disable-next-line
                name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')
            }=([^;]*)`,
        ),
    )
    return matches ? decodeURIComponent(matches[1]) : undefined
}

const setCookie = (name, valueAttr, optionsAttr = {}) => {
    const options = { ...optionsAttr }
    let value = valueAttr
    let { expires } = options
    if (typeof expires === 'number' && expires) {
        const d = new Date()
        d.setTime(d.getTime() + expires * 1000)
        options.expires = d
        expires = d
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString()
    }

    value = encodeURIComponent(value)

    let updatedCookie = `${name}=${value}`

    for (const propName in options) {
        updatedCookie += `; ${propName}`
        const propValue = options[propName]
        if (propValue !== true) {
            updatedCookie += `=${propValue}`
        }
    }

    document.cookie = updatedCookie
}

const deleteCookie = (name) => {
    setCookie(name, '', {
        expires: -1,
    })
}

const localState = {
    data: {
        email: '',
        password: '',
        forgotEmail: '',
        authSuccess: false,
        authFailed: false,
        restore: false,
        restoreFailed: false,
    },
    auth: false,
    loading: true,
    isChecking: false,
    failedToken: false,
}

const actions = {
    async singIn({
        state,
        dispatch,
        commit,
    }) {
        try {
            commit('setState', {
                type: 'loading',
                data: true,
            })
            const response = await this.$api.auth.login(state.data)

            if (response.status === 200) {
                document.cookie = `access_token=${response.data.access_token}; max-age=${response.data.expires_in}; path=/;`
                document.cookie = `refresh_token=${response.data.refresh_token}; max-age=5184000; path=/;`
                document.cookie = `expires_in=${response.data.expires_in}; max-age=${response.data.expires_in}; path=/;`

                commit('setStateLogin', {
                    type: 'authSuccess',
                    data: true,
                })
                commit('setStateLogin', {
                    type: 'authFailed',
                    data: false,
                })
                commit('setStateLogin', {
                    type: 'email',
                    data: '',
                })
                commit('setStateLogin', {
                    type: 'password',
                    data: '',
                })

                await dispatch('getAdminData')

                commit('setState', {
                    type: 'auth',
                    data: true,
                })

                commit('setState', {
                    type: 'loading',
                    data: false,
                })

                await dispatch('getNotification')
                await dispatch('getServices')

                // if (window.matchMedia("(min-width: 3500px)").matches) {
                //   $router.push("/_4screen");
                // } else {
                $router.push('/admin/orders')
                // }
            } else if (response.status === 401) {
                commit('setState', {
                    type: 'loading',
                    data: false,
                })

                Notification({
                    title: 'Error',
                    message: 'Falsche Email oder Passwort',
                    duration: 5000,
                })
            }
        } catch (err) {
            commit('setStateLogin', {
                type: 'authFailed',
                data: true,
            })
            commit('setState', {
                type: 'loading',
                data: false,
            })
        }
    },
    restorePass({
        state,
        commit,
    }) {
        commit('setState', {
            type: 'loading',
            data: true,
        })
        const data = {
            email: state.data.forgotEmail,
        }
        axios
            .post('/restore', data, window.requestConfig)
            .then(() => {
                commit('setStateLogin', {
                    type: 'restore',
                    data: true,
                })
                commit('setStateLogin', {
                    type: 'forgotEmail',
                    data: '',
                })
                commit('setState', {
                    type: 'loading',
                    data: false,
                })
            })
            .catch(() => {
                commit('setStateLogin', {
                    type: 'restoreFailed',
                    data: true,
                })
                commit('setState', {
                    type: 'loading',
                    data: false,
                })
            })
    },
    updateToken({
        commit,
    }) {
        return new Promise((resolve) => {
            const refreshToken = getCookie('refresh_token')
            const params = {
                refresh_token: refreshToken,
            }
            if (refreshToken) {
                axios
                    .post('/refresh_token', params, window.requestConfig)
                    .then((res) => {
                        const auth = res.data.access_token
                        const expAuth = res.data.expires_in
                        const ref = res.data.refresh_token
                        deleteCookie('access_token')
                        setCookie('access_token', auth, {
                            expires: expAuth,
                        })
                        deleteCookie('refresh_token')
                        setCookie('refresh_token', ref, {
                            expires: 5184000,
                        })
                        commit('setState', {
                            type: 'auth',
                            data: true,
                        })
                        commit('setState', {
                            type: 'loading',
                            data: false,
                        })
                        resolve(auth)
                    })
                    .catch(() => {
                        commit('setState', {
                            type: 'auth',
                            data: false,
                        })
                        commit('setState', {
                            type: 'loading',
                            data: false,
                        })
                        commit('setState', {
                            type: 'failedToken',
                            data: true,
                        })
                        resolve()
                    })
            } else {
                logout()
            }
        })
    },
    checkAuth({
        state,
        dispatch,
        commit,
    }) {
        return new Promise((resolve) => {
            if (state.isChecking === false) {
                state.isChecking = !state.isChecking
                const authToken = getCookie('access_token')
                if (authToken) {
                    commit('setState', {
                        type: 'auth',
                        data: true,
                    })
                    state.isChecking = !state.isChecking
                    resolve(authToken)
                } else {
                    dispatch('updateToken').then((res) => {
                        state.isChecking = !state.isChecking
                        resolve(res)
                    })
                }
            } else {
                const awaitToken = setInterval(() => {
                    const authToken = getCookie('access_token')
                    if (authToken) {
                        state.isChecking = !state.isChecking
                        clearInterval(awaitToken)
                        resolve(authToken)
                    } else if (state.failedToken) {
                        clearInterval(awaitToken)
                    }
                }, 200)
            }
        })
    },
    logOut() {
        logout()
    },
    resetSession({
        commit,
    }) {
        commit('setState', {
            type: 'auth',
            data: false,
        })

        commit('setState', {
            type: 'loading',
            data: true,
        })

        setTimeout(() => {
            commit('setState', {
                type: 'loading',
                data: false,
            })
        }, 1500)
    },
}
const mutations = {
    setState(state, {
        type,
        data,
    }) {
        state[type] = data
    },
    setStateLogin(state, {
        type,
        data,
    }) {
        state.data[type] = data
    },
    setIsLogged: (state, v) => {
        state.auth = v
    },
    setIsLoading: (state, v) => {
        state.loading = v
    },
}
const getters = {}

// Work with cookie End
export default {
    state: localState,
    getters,
    actions,
    mutations,
}
